var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferralBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 258,
    viewBox: "0 0 430 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H430V258H0V0Z",
    fill: "#6A2C8D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_10078)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.107 80.9405C372.759 70.0558 362.144 63.3637 359.388 65.9939L352.711 72.3871L390.181 111.821L396.858 105.428C399.606 102.792 393.449 91.8339 383.107 80.9405Z",
    fill: "url(#paint0_linear_535_10078)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.473 96.8756C376.818 107.766 387.434 114.46 390.184 111.827C392.934 109.195 386.776 98.2321 376.431 87.3417C366.085 76.4513 355.469 69.7571 352.72 72.3898C349.97 75.0226 356.127 85.9852 366.473 96.8756Z",
    fill: "url(#paint1_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M376.213 87.5398C386.492 98.3572 392.679 109.203 390.119 111.868C390.139 111.85 390.161 111.84 390.174 111.823C392.921 109.186 386.765 98.2281 376.423 87.3348C366.074 76.4425 355.459 69.7504 352.711 72.3872C352.691 72.4053 352.678 72.4224 352.657 72.4406C355.431 70.0001 365.935 76.7224 376.213 87.5398Z",
    fill: "url(#paint2_linear_535_10078)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367.68 95.7193C375.507 103.959 383.541 109.021 385.624 107.027C387.707 105.033 383.05 96.7372 375.223 88.4979C367.396 80.2586 359.362 75.1959 357.279 77.19C355.196 79.1842 359.853 87.48 367.68 95.7193Z",
    fill: "url(#paint3_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M357.388 77.0897C355.565 79.2561 360.2 87.4145 367.894 95.5064C375.589 103.606 383.479 108.636 385.729 106.912C386.211 106.34 386.238 105.337 385.88 104.033C382.332 102.859 376.569 98.5641 370.921 92.6168C365.267 86.6705 361.268 80.6933 360.265 77.0788C358.983 76.6521 357.986 76.6327 357.396 77.0887L357.388 77.0897Z",
    fill: "url(#paint4_linear_535_10078)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.95 104.331C382.429 103.299 376.511 98.933 370.704 92.8228C364.896 86.7051 360.831 80.5678 359.97 76.9879C358.743 76.6306 357.815 76.6711 357.279 77.1889C355.196 79.1829 359.856 87.4761 367.685 95.7189C375.515 103.962 383.546 109.019 385.629 107.025C386.165 106.507 386.254 105.573 385.958 104.33L385.95 104.331Z",
    fill: "#99570E"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_535_10078)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7728 162.945C88.5746 151.561 94.1935 140.313 91.3216 137.811L84.3431 131.751L48.8304 172.971L55.809 179.031C58.6865 181.524 68.962 174.322 78.7728 162.945Z",
    fill: "url(#paint5_linear_535_10078)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3795 147.848C51.5719 159.229 45.9509 170.478 48.8247 172.974C51.6985 175.47 61.9789 168.267 71.7865 156.886C81.5941 145.505 87.215 134.256 84.3412 131.76C81.4674 129.264 71.1871 136.467 61.3795 147.848Z",
    fill: "url(#paint6_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.5692 156.687C61.8275 167.994 51.6658 175.216 48.7779 172.913C48.7979 172.932 48.8104 172.952 48.8287 172.963C51.7062 175.456 61.9817 168.255 71.7925 156.877C81.6017 145.492 87.2206 134.244 84.3431 131.751C84.3231 131.732 84.3049 131.721 84.2849 131.702C86.9704 134.24 81.3108 145.381 71.5692 156.687Z",
    fill: "url(#paint7_linear_535_10078)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6416 148.944C55.2215 157.554 50.9709 166.067 53.1477 167.958C55.3244 169.848 63.1042 164.4 70.5243 155.79C77.9444 147.179 82.195 138.667 80.0183 136.776C77.8415 134.886 70.0617 140.334 62.6416 148.944Z",
    fill: "url(#paint8_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.1282 136.876C77.8055 135.261 70.1599 140.673 62.8732 149.137C55.5792 157.603 51.3468 165.969 53.272 168.051C53.8855 168.479 54.882 168.409 56.1409 167.927C56.9654 164.269 60.6722 158.099 66.0283 151.886C71.3828 145.666 76.9266 141.098 80.4145 139.749C80.7148 138.427 80.6385 137.429 80.1299 136.883L80.1282 136.876Z",
    fill: "url(#paint9_linear_535_10078)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8523 168.026C56.5381 164.408 60.3008 158.076 65.8032 151.688C71.3131 145.299 77.0091 140.648 80.4763 139.445C80.7131 138.185 80.584 137.262 80.0194 136.776C77.8427 134.885 70.0658 140.336 62.6425 148.949C55.2192 157.562 50.9735 166.072 53.1501 167.963C53.7148 168.448 54.6496 168.448 55.854 168.033L55.8523 168.026Z",
    fill: "#99570E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.67 140.515C333.138 128.144 323.692 119.873 320.561 122.039L312.973 127.309L343.862 172.126L351.45 166.855C354.573 164.681 350.194 152.894 341.67 140.515Z",
    fill: "url(#paint10_linear_535_10078)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M322.764 153.652C331.292 166.028 340.739 174.302 343.864 172.132C346.989 169.962 342.609 158.17 334.081 145.793C325.553 133.417 316.106 125.143 312.981 127.314C309.856 129.484 314.236 141.276 322.764 153.652Z",
    fill: "url(#paint11_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.835 145.955C342.308 158.248 346.735 169.93 343.793 172.162C343.816 172.147 343.839 172.14 343.855 172.125C346.978 169.951 342.598 158.164 334.074 145.785C325.543 133.406 316.097 125.135 312.973 127.309C312.95 127.324 312.935 127.339 312.912 127.354C316.03 125.377 325.362 133.661 333.835 145.955Z",
    fill: "url(#paint12_linear_535_10078)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.137 152.699C330.588 162.063 337.738 168.321 340.105 166.677C342.472 165.033 339.161 156.11 332.709 146.746C326.257 137.383 319.107 131.125 316.74 132.769C314.373 134.412 317.685 143.336 324.137 152.699Z",
    fill: "url(#paint13_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.863 132.687C314.726 134.541 318.037 143.325 324.381 152.522C330.724 161.727 337.737 167.931 340.226 166.579C340.792 166.09 340.974 165.104 340.823 163.759C337.501 162.044 332.475 156.9 327.82 150.142C323.157 143.383 320.136 136.853 319.706 133.126C318.507 132.504 317.524 132.329 316.871 132.687L316.863 132.687Z",
    fill: "url(#paint14_linear_535_10078)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.846 164.065C337.528 162.495 332.36 157.255 327.573 150.311C322.786 143.359 319.723 136.661 319.429 132.99C318.273 132.445 317.349 132.34 316.74 132.767C314.373 134.411 317.688 143.332 324.141 152.699C330.595 162.067 337.743 168.319 340.11 166.676C340.72 166.248 340.953 165.339 340.854 164.065L340.846 164.065Z",
    fill: "#99570E"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_535_10078)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.704 54.8129C102.008 44.8747 111.613 33.7345 126.142 29.9256C140.677 26.1183 154.639 31.0784 157.331 41.0095C160.023 50.9406 165.553 55.79 135.887 65.8953C109.937 74.7379 107.39 64.7425 104.699 54.8114L104.704 54.8129Z",
    fill: "url(#paint15_linear_535_10078)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.287 70.1417C151.821 66.3303 161.655 56.0545 159.252 47.19C156.849 38.3254 143.12 34.229 128.586 38.0403C114.052 41.8517 104.218 52.1275 106.621 60.992C109.024 69.8566 122.754 73.953 137.287 70.1417Z",
    fill: "url(#paint16_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.38
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.692 71.5499L159.092 46.6779C157.84 42.8684 154.448 39.9899 149.802 38.3082L112.248 68.0525C116.133 70.4694 121.598 71.7275 127.692 71.5499Z",
    fill: "url(#paint17_linear_535_10078)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.514 60.573C106.546 60.7083 106.581 60.8508 106.618 60.9877C106.997 62.3945 107.669 63.6856 108.578 64.8401L143.853 36.8974C141.584 36.6031 139.163 36.5348 136.651 36.7019L106.514 60.573Z",
    fill: "url(#paint18_linear_535_10078)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M137.285 70.1429C151.82 66.3356 161.655 56.0549 159.249 47.1914C156.85 38.3238 143.118 34.2288 128.582 38.0362C114.051 41.8507 104.218 52.1257 106.618 60.9877C109.017 69.8553 122.75 73.9503 137.285 70.1429ZM128.629 38.2058C143.008 34.4356 156.598 38.4928 158.974 47.2635C161.35 56.0343 151.617 66.2031 137.238 69.9733C122.859 73.7435 109.269 69.6863 106.893 60.9156C104.518 52.1448 114.25 41.976 128.629 38.2058Z",
    fill: "url(#paint19_linear_535_10078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M137.285 70.1429C151.82 66.3356 161.659 56.0862 159.268 47.257C156.877 38.4278 143.15 34.3585 128.621 38.1673C114.085 41.9747 104.241 52.2226 106.637 61.0533C109.028 69.8825 122.755 73.9518 137.285 70.1429ZM128.663 38.3298C143.042 34.5596 156.623 38.584 158.989 47.3219C161.355 56.0599 151.619 66.1975 137.238 69.9733C122.859 73.7435 109.279 69.7191 106.912 60.9812C104.546 52.2432 114.283 42.1057 128.663 38.3298Z",
    fill: "url(#paint20_linear_535_10078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M136.331 66.611C147.562 63.6659 155.161 55.726 153.304 48.8768C151.448 42.0277 140.839 38.8629 129.608 41.808C118.377 44.7532 110.778 52.6931 112.634 59.5422C114.491 66.3914 125.1 69.5562 136.331 66.611Z",
    fill: "url(#paint21_linear_535_10078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M136.363 66.7299C147.697 63.7575 155.366 55.7424 153.492 48.8277C151.617 41.9129 140.91 38.7169 129.575 41.6892C118.241 44.6616 110.572 52.6767 112.446 59.5914C114.321 66.5062 125.028 69.7022 136.363 66.7299Z",
    fill: "url(#paint22_linear_535_10078)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.298 66.4925C147.529 63.5473 155.128 55.6075 153.272 48.7583C151.415 41.9091 140.806 38.7443 129.575 41.6895C118.345 44.6347 110.745 52.5745 112.602 59.4237C114.458 66.2729 125.068 69.4377 136.298 66.4925Z",
    fill: "#99570E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.196 62.4064C145.993 59.5748 153.506 52.7048 151.976 47.0617C150.447 41.4187 140.454 39.1395 129.656 41.971C118.859 44.8026 111.346 51.6726 112.876 57.3157C114.405 62.9587 124.398 65.2379 135.196 62.4064Z",
    fill: "url(#paint23_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M134.997 61.71C124.422 64.4829 114.622 62.3515 112.781 56.9641C112.805 57.0795 112.828 57.2005 112.864 57.3188C114.394 62.9622 124.387 65.2415 135.184 62.4126C145.98 59.5838 153.496 52.7146 151.968 47.0656C151.938 46.9487 151.9 46.836 151.859 46.7161C152.992 52.2905 145.566 58.9355 134.997 61.71Z",
    fill: "url(#paint24_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_535_10078)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M406.272 218.684C414.659 211.671 420.026 204.252 418.254 202.124L413.96 196.939L383.586 222.327L387.88 227.512C389.647 229.649 397.886 225.697 406.272 218.684Z",
    fill: "url(#paint25_linear_535_10078)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M413.951 196.931C412.181 194.797 403.947 198.75 395.561 205.761C387.176 212.772 381.813 220.186 383.584 222.321C385.355 224.455 393.588 220.502 401.974 213.49C410.359 206.479 415.722 199.065 413.951 196.931Z",
    fill: "url(#paint26_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M401.839 213.33C393.509 220.297 385.355 224.283 383.55 222.29C383.567 222.302 383.569 222.316 383.58 222.335C385.347 224.472 393.587 220.52 401.973 213.507C410.359 206.494 415.727 199.076 413.954 196.947C413.938 196.936 413.921 196.924 413.918 196.91C415.549 199.051 410.172 206.378 401.836 213.353L401.839 213.33Z",
    fill: "url(#paint27_linear_535_10078)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M410.255 200.021C408.916 198.406 402.687 201.398 396.342 206.702C389.998 212.007 385.941 217.616 387.28 219.23C388.62 220.845 394.849 217.854 401.193 212.549C407.538 207.245 411.595 201.636 410.255 200.021Z",
    fill: "url(#paint28_linear_535_10078)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M410.322 200.109C408.839 198.677 402.718 201.651 396.478 206.866C390.245 212.086 386.212 217.599 387.354 219.319C387.749 219.7 388.467 219.767 389.429 219.564C390.451 217.031 393.843 213.047 398.428 209.214C403.013 205.381 407.537 202.758 410.204 202.204C410.572 201.29 410.639 200.57 410.336 200.107L410.322 200.109Z",
    fill: "url(#paint29_linear_535_10078)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M389.215 219.611C390.132 217.091 393.58 212.988 398.297 209.051C403.014 205.113 407.652 202.447 410.281 202.002C410.599 201.126 410.615 200.444 410.271 200.025C408.925 198.408 402.699 201.395 396.355 206.708C390.002 212.016 385.951 217.627 387.288 219.238C387.633 219.657 388.309 219.768 389.22 219.603L389.215 219.611Z",
    fill: "#99570E"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.859 73.3948L279.814 79.1464L285.543 80.1049L279.814 81.0633L278.859 86.8149L277.905 81.0633L272.175 80.1049L277.905 79.1464L278.859 73.3948Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9561 137.554L34.6896 141.973L39.0914 142.709L34.6896 143.446L33.9561 147.864L33.2226 143.446L28.8208 142.709L33.2226 141.973L33.9561 137.554Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 189.644C247.427 189.644 273.308 163.661 273.308 131.61C273.308 99.5597 247.427 73.5774 215.5 73.5774C183.573 73.5774 157.692 99.5597 157.692 131.61C157.692 163.661 183.573 189.644 215.5 189.644Z",
    fill: "#D68F30"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M161.623 146.685V152.614C162.227 154.182 162.902 155.73 163.638 157.228V146.685H161.623ZM168.214 157.845V164.967C169.02 166.111 169.856 167.234 170.733 168.316V157.845H168.214ZM176.941 167.153V174.832C177.919 175.712 178.927 176.552 179.965 177.361V167.153H176.941ZM187.685 174.225V182.48C188.672 183.027 189.68 183.543 190.708 184.039V174.225H187.685ZM199.869 178.727V187.468C200.867 187.752 201.875 188.005 202.892 188.237V178.727H199.869ZM214.13 180.285V189.603C214.583 189.613 215.037 189.633 215.5 189.633C216.055 189.633 216.609 189.603 217.153 189.593V180.285H214.13ZM228.39 178.656V188.166C229.408 187.934 230.416 187.671 231.414 187.387V178.656H228.39ZM240.544 174.093V183.917C241.572 183.421 242.58 182.885 243.568 182.329V174.093H240.544ZM251.257 166.96V177.179C252.295 176.365 253.303 175.515 254.281 174.629V166.96H251.257ZM262.958 157.622H260.439V168.094C261.315 167.001 262.162 165.878 262.958 164.725V157.622ZM269.509 146.422H267.493V156.985C268.229 155.457 268.904 153.889 269.509 152.3V146.422Z",
    fill: "#BC6F00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 184.423C247.427 184.423 273.308 158.441 273.308 126.39C273.308 94.339 247.427 68.3567 215.5 68.3567C183.573 68.3567 157.692 94.339 157.692 126.39C157.692 158.441 183.573 184.423 215.5 184.423Z",
    fill: "#FFF176"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 179.253C244.582 179.253 268.158 155.585 268.158 126.39C268.158 97.1942 244.582 73.5266 215.5 73.5266C186.418 73.5266 162.842 97.1942 162.842 126.39C162.842 155.585 186.418 179.253 215.5 179.253Z",
    fill: "#F2BC1A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.741 128.413C162.368 121.452 163.567 114.39 165.986 107.774C168.505 101.177 172.365 95.0764 177.233 89.8963C187.009 79.5159 201.199 73.4961 215.5 73.4253C229.801 73.5062 244.001 79.5159 253.756 89.9064C258.634 95.0764 262.484 101.187 265.003 107.774C267.432 114.4 268.632 121.452 268.249 128.413H268.047C268.027 121.469 266.658 114.596 264.016 108.178C261.369 101.768 257.504 95.9366 252.638 91.0092C247.768 86.0867 241.98 82.1745 235.606 79.4957C229.233 76.8245 222.396 75.4491 215.49 75.4491C208.584 75.4491 201.746 76.8245 195.374 79.4957C188.999 82.1745 183.212 86.0867 178.342 91.0092C173.472 95.9339 169.606 101.766 166.963 108.178C164.321 114.596 162.952 121.469 162.932 128.413H162.741Z",
    fill: "#E08F00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 68.3666C183.573 68.3666 157.692 94.3479 157.692 126.4C157.692 158.451 183.573 184.433 215.5 184.433C247.428 184.433 273.308 158.451 273.308 126.4C273.308 94.3479 247.428 68.3666 215.5 68.3666ZM215.5 179.263C186.415 179.263 162.842 155.598 162.842 126.4C162.842 97.1909 186.415 73.5265 215.5 73.5265C244.585 73.5265 268.158 97.1909 268.158 126.39C268.158 155.588 244.585 179.263 215.5 179.263Z",
    fill: "#FFF176"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M189.287 85.8496L190.567 89.8258L194.739 88.2272V89.8258L191.363 92.2843L192.653 94.6517V96.2604L189.287 93.8019L185.91 96.2604V94.6517L187.2 92.2843L183.834 89.8258V88.2272L187.997 89.8258L189.287 85.8496ZM173.182 108.674L174.472 112.65L178.634 111.052V112.65L175.268 115.109L176.558 117.487V119.085L173.182 116.627L169.816 119.085V117.487L171.106 115.109L167.73 112.65V111.052L171.902 112.65L173.182 108.674ZM172.708 136.811L173.998 140.787L178.16 139.188V140.787L174.794 143.245L176.084 145.623V147.221L172.708 144.763L169.342 147.221V145.623L170.632 143.245L167.256 140.787V139.188L171.428 140.787L172.708 136.811ZM189.901 159.15L191.191 163.126L195.354 161.527V163.126L191.988 165.584L193.278 167.952V169.561L189.901 167.102L186.535 169.561V167.952L187.825 165.584L184.449 163.126V161.527L188.621 163.126L189.901 159.15ZM241.713 85.8496L240.433 89.8258L236.261 88.2272V89.8258L239.637 92.2843L238.347 94.6517V96.2604L241.713 93.8019L245.089 96.2604V94.6517L243.799 92.2843L247.165 89.8258V88.2272L243.003 89.8258L241.713 85.8496ZM257.818 108.674L256.528 112.65L252.366 111.052V112.65L255.732 115.109L254.442 117.487V119.085L257.818 116.627L261.184 119.085V117.487L259.894 115.109L263.27 112.65V111.052L259.098 112.65L257.818 108.674ZM258.292 136.811L257.002 140.787L252.839 139.188V140.787L256.205 143.245L254.915 145.623V147.221L258.292 144.763L261.658 147.221V145.623L260.368 143.245L263.744 140.787V139.188L259.571 140.787L258.292 136.811ZM241.098 159.15L239.808 163.126L235.646 161.527V163.126L239.012 165.584L237.722 167.952V169.561L241.098 167.102L244.464 169.561V167.952L243.174 165.584L246.551 163.126V161.527L242.378 163.126L241.098 159.15Z",
    fill: "#D38200"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M241.098 157.541L242.378 161.517H246.551L243.174 163.975L244.464 167.952L241.098 165.493L237.722 167.952L239.012 163.975L235.646 161.517H239.808L241.098 157.541ZM258.292 135.212L259.571 139.188H263.744L260.368 141.646L261.658 145.623L258.292 143.164L254.915 145.623L256.205 141.646L252.839 139.188H257.002L258.292 135.212ZM257.818 107.075L259.098 111.052H263.27L259.894 113.51L261.184 117.486L257.818 115.028L254.442 117.486L255.732 113.51L252.366 111.052H256.528L257.818 107.075ZM241.713 84.2407L243.003 88.2168H247.165L243.799 90.6753L245.089 94.6514L241.713 92.1929L238.347 94.6514L239.637 90.6753L236.261 88.2168H240.433L241.713 84.2407Z",
    fill: "#FFF176"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M215.55 167.952L216.84 171.928L221.003 170.329V171.928L217.637 174.386L218.927 176.764V178.362L215.55 175.904L212.184 178.362V176.764L213.474 174.386L210.098 171.928V170.329L214.27 171.928L215.55 167.952Z",
    fill: "#D38200"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M215.55 165.827L216.84 169.803H221.003L217.637 172.262L218.927 176.238L215.55 173.779L212.184 176.238L213.474 172.262L210.098 169.803H214.27L215.55 165.827Z",
    fill: "#FFF176"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M215.55 77.2904L216.84 81.2665L221.003 79.668V81.2665L217.637 83.725L218.927 86.1026V87.7011L215.55 85.2426L212.184 87.7011V86.1026L213.474 83.725L210.098 81.2665V79.668L214.27 81.2665L215.55 77.2904Z",
    fill: "#D38200"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M215.55 75.6918L216.84 79.6679H221.003L217.636 82.1264L218.926 86.1025L215.55 83.644L212.184 86.1025L213.474 82.1264L210.098 79.6679H214.27L215.55 75.6918ZM189.901 157.541L188.621 161.517H184.449L187.825 163.976L186.535 167.952L189.901 165.493L193.278 167.952L191.988 163.976L195.354 161.517H191.191L189.901 157.541ZM172.708 135.212L171.428 139.188H167.256L170.632 141.647L169.342 145.623L172.708 143.164L176.084 145.623L174.794 141.647L178.16 139.188H173.998L172.708 135.212ZM173.182 107.076L171.902 111.052H167.73L171.106 113.51L169.816 117.487L173.182 115.028L176.558 117.487L175.268 113.51L178.634 111.052H174.472L173.182 107.076ZM189.287 84.241L187.997 88.2171H183.834L187.2 90.6756L185.91 94.6517L189.287 92.1932L192.653 94.6517L191.363 90.6756L194.739 88.2171H190.567L189.287 84.241Z",
    fill: "#FFF176"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M239.526 109.099L215.5 95.4102L191.474 109.099H239.526Z",
    fill: "#F2BC1A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M234.066 102.667C237.206 102.652 239.774 105.219 239.769 108.382C239.769 111.539 237.192 114.121 234.066 114.107C230.93 114.092 228.388 111.51 228.402 108.347C228.417 105.214 230.94 102.681 234.066 102.667Z",
    fill: "#FFF176"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.222 123.821C228.931 120.806 231.695 119.37 234.948 118.745C236.124 118.519 237.344 118.465 238.544 118.425C239.965 118.376 240.435 118.902 240.44 120.348C240.44 120.516 240.44 120.688 240.44 120.855C240.317 123.909 239.715 126.826 237.789 129.3C235.913 131.71 233.292 132.807 230.372 133.264C229.235 133.441 228.069 133.5 226.913 133.5C225.962 133.5 225.409 132.934 225.384 132.005C225.311 129.128 225.781 126.359 227.217 123.821H227.222Z",
    fill: "#FFF176"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M202.451 103.375L203.945 124.814C204.053 126.476 204.43 127.706 205.077 128.508C205.723 129.304 206.85 129.649 208.452 129.541C210.015 129.457 211.216 128.94 212.058 127.986C212.901 127.032 213.268 125.724 213.161 124.061L211.421 102.662L217.585 102.298L218.917 121.607C218.971 122.497 218.996 123.397 218.996 124.307C218.996 125.217 218.937 126.083 218.814 126.953C218.692 127.824 218.486 128.655 218.197 129.447C217.908 130.239 217.487 130.952 216.933 131.587C216.649 131.887 216.419 132.123 216.237 132.305C216.056 132.487 215.875 132.644 215.703 132.782C215.527 132.919 215.336 133.038 215.125 133.136C214.915 133.239 214.665 133.357 214.366 133.49C213.92 133.652 213.602 133.775 213.406 133.854C213.21 133.933 213.019 134.006 212.827 134.065C212.636 134.124 212.382 134.188 212.058 134.257C211.735 134.326 211.245 134.439 210.584 134.602C210.231 134.68 209.922 134.759 209.643 134.833C209.369 134.906 209.099 134.956 208.835 134.985C208.57 135.015 208.281 135.034 207.967 135.044C207.649 135.059 207.281 135.049 206.865 135.025C206.003 134.97 205.312 134.892 204.793 134.793C204.273 134.69 203.725 134.508 203.146 134.238C202.568 133.982 202.073 133.726 201.672 133.475C201.27 133.224 200.922 132.949 200.633 132.644C200.344 132.339 200.094 131.99 199.884 131.592C199.673 131.193 199.462 130.701 199.247 130.121C199.085 129.673 198.933 129.113 198.791 128.439C198.649 127.765 198.531 127.072 198.438 126.358C198.345 125.65 198.262 124.981 198.198 124.361C198.13 123.742 198.085 123.255 198.056 122.901L196.924 103.729L202.441 103.365L202.451 103.375Z",
    fill: "#FFF176"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.44 142.663C240.381 142.825 240.327 142.987 240.264 143.15C239.808 144.301 238.975 145.019 237.74 145.043C235.222 145.097 232.699 145.068 230.181 145.058C229.598 145.058 229.255 144.694 229.216 144.109C229.196 143.809 229.216 143.509 229.216 143.135C228.383 143.135 227.574 143.125 226.761 143.155C226.678 143.155 226.56 143.391 226.526 143.538C225.752 146.534 223.998 148.722 221.22 150.07C219.922 150.699 218.54 150.96 217.1 150.96C211.98 150.96 206.86 150.98 201.74 150.95C196.875 150.921 193.088 147.768 192.206 143.007C192.03 142.053 192.074 141.054 192.059 140.081C192.049 139.623 192.392 139.284 192.848 139.205C193.049 139.171 193.255 139.181 193.46 139.181C204.077 139.181 214.694 139.181 225.311 139.181C226.521 139.181 226.756 139.412 226.756 140.612C226.756 140.799 226.756 140.986 226.756 141.241H229.211C229.211 140.927 229.201 140.632 229.211 140.341C229.23 139.658 229.593 139.279 230.269 139.274C232.709 139.264 235.154 139.254 237.594 139.279C238.877 139.294 239.906 140.105 240.313 141.33C240.347 141.428 240.396 141.527 240.435 141.625V142.668L240.44 142.663Z",
    fill: "#FFF176"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_535_10078",
    x: 38.0732,
    y: 111.695,
    width: 324.385,
    height: 77.8293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_535_10078"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_535_10078",
    x1: 358.515,
    y1: 66.6839,
    x2: 396.132,
    y2: 105.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_535_10078",
    x1: 365.742,
    y1: 97.5746,
    x2: 376.079,
    y2: 87.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_535_10078",
    x1: 355.15,
    y1: 69.9057,
    x2: 392.767,
    y2: 109.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_535_10078",
    x1: 367.087,
    y1: 96.287,
    x2: 375.953,
    y2: 87.8648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_535_10078",
    x1: 356.284,
    y1: 77.9962,
    x2: 384.733,
    y2: 107.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_535_10078",
    x1: 53.8129,
    y1: 170.191,
    x2: 92.4881,
    y2: 50.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_535_10078",
    x1: 200.266,
    y1: 183.764,
    x2: 200.266,
    y2: 123.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_535_10078",
    x1: 36.0498,
    y1: 174.593,
    x2: 86.89,
    y2: 30.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_535_10078",
    x1: 200.266,
    y1: 184.069,
    x2: 200.266,
    y2: 116.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_535_10078",
    x1: 56.6758,
    y1: 180.916,
    x2: 106.013,
    y2: 38.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_535_10078",
    x1: 53.8129,
    y1: 170.191,
    x2: 92.4881,
    y2: 50.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_535_10078",
    x1: 200.266,
    y1: 183.764,
    x2: 200.266,
    y2: 123.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_535_10078",
    x1: 36.0498,
    y1: 174.593,
    x2: 86.89,
    y2: 30.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_535_10078",
    x1: 200.266,
    y1: 184.069,
    x2: 200.266,
    y2: 116.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_535_10078",
    x1: 56.6758,
    y1: 180.916,
    x2: 106.013,
    y2: 38.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_535_10078",
    x1: 156.195,
    y1: 45.9262,
    x2: 106.869,
    y2: 59.2964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_535_10078",
    x1: 130.145,
    y1: 43.7709,
    x2: 137.919,
    y2: 73.4132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_535_10078",
    x1: 134.042,
    y1: 50.9111,
    x2: 138.6,
    y2: 68.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_535_10078",
    x1: 124.898,
    y1: 47.2761,
    x2: 128.348,
    y2: 60.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_535_10078",
    x1: 138.364,
    y1: 73.6845,
    x2: 129.994,
    y2: 41.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_535_10078",
    x1: 138.365,
    y1: 73.6888,
    x2: 130.028,
    y2: 41.8964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_535_10078",
    x1: 154.503,
    y1: 53.3225,
    x2: 113.93,
    y2: 64.3203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_535_10078",
    x1: 154.696,
    y1: 53.2718,
    x2: 113.737,
    y2: 64.3742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_535_10078",
    x1: 131.659,
    y1: 49.3608,
    x2: 135.295,
    y2: 63.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_535_10078",
    x1: 133.991,
    y1: 57.5517,
    x2: 135.87,
    y2: 64.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_535_10078",
    x1: 417.63,
    y1: 201.365,
    x2: 387.158,
    y2: 226.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_535_10078",
    x1: 395.094,
    y1: 205.198,
    x2: 401.761,
    y2: 213.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_535_10078",
    x1: 415.467,
    y1: 198.758,
    x2: 384.995,
    y2: 224.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_535_10078",
    x1: 395.965,
    y1: 206.247,
    x2: 401.674,
    y2: 213.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_535_10078",
    x1: 409.557,
    y1: 199.179,
    x2: 386.508,
    y2: 218.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_10078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.274,
    height: 41.2781,
    fill: "white",
    transform: "matrix(0.132466 0.991188 -0.991051 0.13348 391.909 61.2374)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_535_10078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.0138,
    height: 46.1673,
    fill: "white",
    transform: "matrix(0.966489 0.256708 -0.254851 0.96698 111.766 21.0817)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_535_10078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.066,
    height: 20.966,
    fill: "white",
    transform: "matrix(0.562912 -0.826517 0.824475 0.565899 381 222.851)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralBackground);
export default __webpack_public_path__ + "static/media/referral-background.0ef174e7f8facf7ac63d22788083893b.svg";
export { ForwardRef as ReactComponent };